<template>
  <div class="large-image-blocks critical-component-clear">
    <div
      v-for="(block, index) in blocks"
      :key="`large-image-blocks-${index}`"
      class="large-image-blocks__block"
      :class="{
        'large-image-blocks__block--center': block.center
      }"
      :style="{
        '--delay': `${0.1 * index}s`
      }"
    >
      <div class="large-image-blocks__content">
        <h2
          v-if="block.title"
          class="
          large-image-blocks__line
          text-heading-s
          text-heading-m-desktop
        "
          v-text="block.title"
        />

        <p
          v-if="block.subtitle"
          class="
          large-image-blocks__line
          text-body-2xs
          text-body-s-desktop
        "
          v-text="block.subtitle"
        />

        <a
          v-if="block.url && block.button"
          class="
          large-image-blocks__line
          large-image-blocks__button
          text-button-s
          text-button-m-desktop
        "
          :href="block.url"
          v-text="block.button"
        />
      </div>

      <component
        :is="getImageContainer(block)"
        :href="block.url"
        class="large-image-blocks__image"
        :style="{
          '--overlay-opacity': block.overlayOpacity
        }"
      >
        <video
          v-if="block.video"
          :poster="block.image && block.image.src"
          playsinline
          :autoplay="!reducedMotion"
          loop
          muted
        >
          <source
            :src="block.video"
            type="video/mp4"
          >
        </video>

        <art-direction
          v-else
          :image="block.image"
          :image-desktop="block.imageDesktop"
        />
      </component>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Large image blocks (large-image-blocks)
 * -----------------------------------------------------------------------------
 * Full-bleed image blocks with supporting content on hover.
 *
 * @param {Array} blocks - A list of blocks with an image and content.
 *
 */
import ArtDirection from '~global/images/art-direction'

export default {
  name: 'LargeImageBlocks',

  components: {
    ArtDirection,
  },

  props: {
    blocks: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      reducedMotion: true,
    }
  },

  computed: {

    /**
     * Returns if the dual layout is active.
     * @returns {Boolean} - The dual layout state.
     */
    isDualLayout() {
      return this.blocks.length > 1
    },

    /**
     * Returns the dynamic ratios for the images.
     * @returns {Object} - An object of mobile and desktop ratios.
     */
    ratios() {
      return {
        mobile: '9:16',
        desktop: this.isDualLayout ? '4:5' : '3:2',
      }
    },
  },

  mounted() {
    this.detectReducedMotion()
  },

  methods: {

    /**
     * Detects and sets the reduced motion option.
     */
    detectReducedMotion() {
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    },

    /**
     * Returns the dynamic image container element.
     * @param {Object} block - The block object.
     * @returns {String} - The element tag.
     */
    getImageContainer(block) {
      if (block.url) {
        return 'a'
      }

      return 'div'
    },
  },
}
</script>

<style lang="scss">
@import './large-image-blocks';
</style>
